import React, { useEffect, useState } from 'react';
import Cookies from "js-cookie";
import api from '../utils/axiosInstance';
import { useImmerReducer } from 'use-immer';
import { Button, TextField, Container, Typography, Box, Grid, Avatar, CircularProgress, 
        IconButton, Card, CardMedia, CardActions, CardContent, Link, Breadcrumbs, useMediaQuery } from '@mui/material'; 
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { useNavigate, useParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import defaultProfilePicture from "./Assets/default3.jpg";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import RoomIcon from '@mui/icons-material/Room';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useTheme } from '@mui/material/styles';
import { MapContainer, TileLayer, Marker, useMap, Popup } from 'react-leaflet';
import stadiumIconPng from "./Assets/Mapicons/stadium.png";
import universityIconPng from "./Assets/Mapicons/university.png";
import { Icon, PolyUtil } from 'leaflet';
import axios from 'axios';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import ListingUpdate from './ListingUpdate';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// Create makeStyles to include safe handling of theme object
const useStyles = makeStyles((theme) => ({
  sliderContainer: {
    position: 'relative',
    marginTop: theme?.spacing ? theme.spacing(2) : '16px',  // Fallback to '16px' if theme.spacing is not available
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // original code
  // leftArrow: {
  //   position: 'absolute',
  //   cursor: 'pointer',
  //   fontSize: '3rem',
  //   color: '#1976d2',
  //   top: '50%',
  //   left: '5%',
  //   zIndex: 10,
  //   '&:hover': {
  //     backgroundColor: 'rgba(0, 0, 0, 0.5)',
  //     borderRadius: '50%',
  //   },
  // },
  // rightArrow: {
  //   position: 'absolute',
  //   cursor: 'pointer',
  //   fontSize: '3rem',
  //   color: '#1976d2',
  //   top: '50%',
  //   right: '5%',
  //   zIndex: 10,
  //   '&:hover': {
  //     backgroundColor: 'rgba(0, 0, 0, 0.5)',
  //     borderRadius: '50%',
  //   },
  // },
  
  // added from chatgpt
  leftArrow: {
    position: 'absolute',
    cursor: 'pointer',
    fontSize: '3rem',
    color: '#1976d2',
    top: '50%',
    transform: 'translateY(-50%)', // Ensures vertical centering
    left: '2%',  // Adjust position
    zIndex: 10,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '50%',
    },
  },
  rightArrow: {
    position: 'absolute',
    cursor: 'pointer',
    fontSize: '3rem',
    color: '#1976d2',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '2%',
    zIndex: 10,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '50%',
    },
  },
  
  card: {
    padding: theme?.spacing ? theme.spacing(2) : '16px',
    marginBottom: theme?.spacing ? theme.spacing(2) : '16px',
    [theme?.breakpoints?.down('sm')]: {
      padding: theme?.spacing ? theme.spacing(1) : '8px',
    },
  },
  listingInfo: {
    marginBottom: theme?.spacing ? theme.spacing(1) : '8px',
  },
  facilityGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginTop: theme?.spacing ? theme.spacing(1) : '8px',
    padding: theme?.spacing ? theme.spacing(2) : '16px',
    border: '1px solid black',
    [theme?.breakpoints?.down('sm')]: {
      padding: theme?.spacing ? theme.spacing(1) : '8px',
    },
  },
  description: {
    padding: theme?.spacing ? theme.spacing(2) : '16px',
    border: '1px solid black',
    marginTop: theme?.spacing ? theme.spacing(2) : '16px',
    [theme?.breakpoints?.down('sm')]: {
      padding: theme?.spacing ? theme.spacing(1) : '8px',
    },
  },
  // original code
  // picture: {
  //   width: "100%",
  //   height: "auto",
  //   maxWidth: "45rem",
  //   maxHeight: "35rem",
  //   [theme?.breakpoints?.down('sm')]: {
  //     maxWidth: "100%",
  //     maxHeight: "20rem",
  //   },
  // },
  // addd from chatgpt
  picture: {
    width: '100%',
    maxWidth: '45rem',
    height: '35rem',  // Fixed height for consistency
    objectFit: 'cover', // Maintains aspect ratio and crops excess if needed
    borderRadius: '8px', // Adds a subtle border-radius for better visuals
    [theme?.breakpoints?.down('sm')]: {
      height: '20rem', // Adjust height for small screens
    },
  },
  sliderImage: {
    transition: 'opacity 0.5s ease-in-out', // Smooth fade transition
  },

  [theme?.breakpoints?.down('sm')]: {
    fontSize: '2.5rem', // Smaller arrows on mobile
  },
  
  
}));

function ListingDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const userCookie = Cookies.get('user'); 
  const userId = userCookie ? JSON.parse(userCookie).user_id : null;
  // const [open, setOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
 
  const handleDeleteOpen = () => {
    setDeleteDialogOpen(true);
  };

  const handleUpdateOpen = () => {
    setUpdateDialogOpen(true);
  };

  const handleClose = () => {
    setDeleteDialogOpen(false);
    setUpdateDialogOpen(false);
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  const stadiumIcon = new Icon(
    {
      iconUrl: stadiumIconPng,
      iconSize: [40,40]
    }
  );

  const universityIcon = new Icon(
    {
      iconUrl: universityIconPng,
      iconSize: [40,40]
    }
  );

  const initialState = {
    dataIsLoading: true,
    listingInfo: "",
    sellerProfileInfo: "",
  };

  function ReducerFunction(draft, action) {
    switch (action.type) {
      case "catchListingInfo":
        draft.listingInfo = action.listingObject;
        break;
      case "loadingDone":
        draft.dataIsLoading = false;
        break;
      case "catchSellerProfileInfo":
        draft.sellerProfileInfo = action.profileObject
        break;
      default:
        break;
    }
  }

  const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);

  useEffect(() => {
    async function GetListingInfo() {
      try {
        const userCookie = Cookies.get('user');
        const userId = userCookie ? JSON.parse(userCookie).user_id : null;
        const response = await api.get(`${apiUrl}/api/listing/${params.id}/`);
        
        dispatch({
          type: "catchListingInfo",
          listingObject: response.data,
        });

        // dispatch({type: 'loadingDone'});

      } catch (e) {
        console.log(e.response);
      }
    }
    GetListingInfo();
  }, [params.id]);

  useEffect(() => {
    console.log("params", params);
    if (state.listingInfo) {
      async function GetProfileInfo() {
        try {
          const userCookie = Cookies.get('user');
          const userId = userCookie ? JSON.parse(userCookie).user_id : null;
          const response = await api.get(`${apiUrl}/api/profile/${state.listingInfo.seller}/`);
        
          console.log(response.data)
          dispatch({
            type: "catchSellerProfileInfo",
            profileObject: response.data,
          });

          dispatch({type: 'loadingDone'});

        } catch (e) {
          console.log(e.response);
        }
      }
      GetProfileInfo();
    }
    // } else {
    //   console.log("Seller ID is undefined");
    // }
  }, [state.listingInfo]);

  const listingPictures = [
    state.listingInfo.picture1,
    state.listingInfo.picture2,
    state.listingInfo.picture3,
    state.listingInfo.picture4,
    state.listingInfo.picture5,
  ].filter((picture) => picture !== null);

  const [currentPicture, setCurrentPicture] = useState(0);

  function NextPicture() {
    if (currentPicture === listingPictures.length - 1) {
      return setCurrentPicture(0);
    } else {
      return setCurrentPicture(currentPicture + 1);
    }
  }

  function PreviousPicture() {
    if (currentPicture === 0) {
      return setCurrentPicture(listingPictures.length - 1);
    } else {
      return setCurrentPicture(currentPicture - 1);
    }
  }

  const date = state.listingInfo.date_posted ? new Date(state.listingInfo.date_posted) : null;

  const formattedDate = date
    ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
    : 'Date not available';

  async function handleDelete() {
    try {
      const response = await api.delete(`${apiUrl}/api/listing/${params.id}/delete/`);
    
      // Success message
      if (response.status === 204) { // 204 No Content indicates a successful deletion
        toast.success("Property deleted successfully.");
        navigate('/listings'); // Redirect to listings page after deletion
      }
    } catch (e) {
      // Handle different error responses with specific toast messages
      if (e.response && e.response.status === 404) {
        console.error("Listing not found:", e.response.data);
        toast.error("Listing not found. It may have already been deleted.");
      } else if (e.response && e.response.status === 401) {
        console.error("Unauthorized:", e.response.data);
        toast.error("Unauthorized action. Please log in again.");
      } else if (e.response && e.response.status === 429) {
        console.error("Rate limit exceeded:", e.response.data);
        toast.error("Too many requests. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", e.message);
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setDeleteDialogOpen(false); // Close the delete confirmation dialog
    }
  }
    
  // worked well just that i added toast messages above
  // async function handleDelete() {
  //   try {
  //     const response = await axios.delete(`http://localhost:8000/api/listing/${params.id}/delete/`);
  //     console.log(response.data);
  //     navigate('/listings');
  //   } catch (e) {
  //     console.log(e.response.data);
  //   } finally {
  //     // setOpen(false); // Close the modal after deletion
  //     setDeleteDialogOpen(false)
  //   }
  // }

  // const handleUpdate = async () => {
  //   // Update logic here
  //   console.log("Update action triggered");
  //   setUpdateDialogOpen(false); // Close the dialog after action
  // };

  if (state.dataIsLoading === true) {
    return(
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    )
  }

  function POiIcon(poi) {
    if (poi.type === 'Stadium') {
      return stadiumIcon;
    } else if (poi.type === 'University') {
      return universityIcon;
    } else {
      return null;  // fallback to a default icon if needed
    }
  }  

  function DegreeToRadian(coordinate) {
    return (coordinate * Math.PI) / 180;
  }

  function CalculateDistance(poi) {
    const latitude1 = DegreeToRadian(state.listingInfo.latitude);
    const longitude1 = DegreeToRadian(state.listingInfo.longitude);
    const latitude2 = DegreeToRadian(poi.location.coordinates[0]);
    const longitude2 = DegreeToRadian(poi.location.coordinates[1]);
  
    const latDiff = latitude2 - latitude1;
    const lonDiff = longitude2 - longitude1;
    const R = 6371000 / 1000; // Earth's radius in kilometers
  
    const a =
      Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
      Math.cos(latitude1) *
      Math.cos(latitude2) *
      Math.sin(lonDiff / 2) *
      Math.sin(lonDiff / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
    const d = R * c;
  
    return d.toFixed(2); // Returns distance in kilometers
  }  

  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
          <HomeIcon fontSize="large" />
          <Typography variant={isMobile ? 'h6' : 'h4'} ml={1}>
            Listing Detail
          </Typography>
      </Box>
      <Container maxWidth="md">
        <Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: "1rem" }} display="flex" justifyContent="center">
          {/* <Link underline="hover" color="inherit" onClick={() => navigate("/listing")} 
          style={{ cursor: "pointer" }}>
            Listing
          </Link> */}
          <Typography sx={{ color: 'text.primary' }}>{state.listingInfo.title}</Typography>
        </Breadcrumbs>

        <Card className={classes.card}>
          <Grid container justifyContent="center" className={classes.sliderContainer}>
            {listingPictures.map((picture, index) => (
              <div key={index}>
                {index === currentPicture && (
                 <Box className={classes.sliderContainer}>
                  {/* <ArrowBackIosIcon className={classes.leftArrow} onClick={PreviousPicture} /> */}
                  <img 
                    // src={picture} 
                    src={`https://res.cloudinary.com/dvisrqloj/${picture}`} 
                    alt={`Listing picture ${index + 1}`} 
                    // className={classes.picture} 
                    className={`${classes.picture} ${classes.sliderImage}`}
                  />
                  {/* <ArrowForwardIosIcon className={classes.rightArrow} onClick={NextPicture} /> */}
                 </Box>
                )}
              </div>
            ))}
            <ArrowCircleLeftIcon 
              className={classes.leftArrow} 
              onClick={PreviousPicture} 
            />
            <ArrowCircleRightIcon 
              className={classes.rightArrow} 
              onClick={NextPicture} 
            />
          </Grid>

          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} className={classes.listingInfo}>
                <RoomIcon /> {" "}
                <Typography variant={isMobile ? 'body1' : 'h6'}>{state.listingInfo.district}</Typography>
              </Grid>
              <Grid item xs={12} md={6} className={classes.listingInfo}>
                <Typography variant='subtitle1'>{formattedDate}</Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant='h6' style={{fontWeight: "bolder", color: "green"}}>
                  {state.listingInfo.listing_type} | {" "}
                  {state.listingInfo.property_status === "Sale"
                    ? `₦${state.listingInfo.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                    : `₦${state.listingInfo.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/${state.listingInfo.rental_frequency}`
                  }
                </Typography>
              </Grid>
            </Grid>
          </CardContent>

          <Grid container className={classes.facilityGrid}>
            {state.listingInfo.rooms && (
              <Grid item>
                <Typography variant='h6'> {state.listingInfo.rooms} Rooms</Typography>
              </Grid>
            )}
            {state.listingInfo.furnished && (
              <Grid item>
                <CheckBoxIcon /> Furnished
              </Grid>
            )}
            {state.listingInfo.pool && (
              <Grid item>
                <CheckBoxIcon /> Pool
              </Grid>
            )}
            {state.listingInfo.elevator && (
              <Grid item>
                <CheckBoxIcon /> Elevator
              </Grid>
            )}
            {state.listingInfo.cctv && (
              <Grid item>
                <CheckBoxIcon /> CCTV
              </Grid>
            )}
            {state.listingInfo.parking && (
              <Grid item>
                <CheckBoxIcon /> Parking
              </Grid>
            )}
          </Grid>

          <Box className={classes.description}>
            <Typography variant="h6">Description</Typography>
            <Typography variant="body1">{state.listingInfo.description}</Typography>
          </Box>
        </Card>

        <Grid container spacing={2} alignItems="center" direction="column">
          <Grid item>
            {state.sellerProfileInfo.profile_picture ? (
              <Avatar
                src={typeof state.sellerProfileInfo.profile_picture === 'string'
                  // ? state.sellerProfileInfo.profile_picture // Use URL if it's a string
                  ? `https://res.cloudinary.com/dvisrqloj/${state.sellerProfileInfo.profile_picture}`
                  : URL.createObjectURL(state.sellerProfileInfo.profile_picture)}  // Use file object for new uploads
                alt="Profile Picture"
                sx={{ width: 150, height: 150 }}
                onClick={() => {
                  const sellerId = state.listingInfo.seller; // Ensure seller ID is from listingInfo
                  if (sellerId) {
                    navigate(`/agency/${sellerId}`);
                  } else {
                    console.log("Seller ID is undefined");
                  }
                }}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <Avatar
                src={defaultProfilePicture}
                alt="Profile Picture"
                sx={{ width: 150, height: 150 }}
              />
            )}
          </Grid>

          <Grid item>
            <Typography variant="h5" style={{ textAlign: 'center' }}>
              <span style={{ fontWeight: 'bold' }}>
                {state.sellerProfileInfo.agency_name || 'Agency name not available'}
              </span>
            </Typography>

            <Typography variant="h6" style={{ textAlign: 'center' }}>
              <IconButton>
                <LocalPhoneIcon sx={{ mr: 1 }} /> 
                {state.sellerProfileInfo.phone_number || 'Phone number not available'}
              </IconButton>
            </Typography>
          </Grid>
        </Grid>

        <Grid item container style={{marginTop: "1rem"}} spacing={1} justifyContent="space-between">
          <Grid item xs={3} style={{overflow: "auto", height: "35rem"}}>
            {state.listingInfo.listing_pois_within_10km.map((poi) => {
              return (
                <div key={poi.id} style={{marginBottom: "0.5rem", border: "1px solid black"}}>
                  <Typography variant='h6'>{poi.name}</Typography>
                  <Typography variant='subtitle1'>
                    {poi.type} | <span>{CalculateDistance(poi)} kilometres</span>
                  </Typography>
                </div>
              )
            })}
          </Grid>
          <Grid item xs={9} style={{height: "35rem"}}>
            <MapContainer center={[state.listingInfo.latitude, state.listingInfo.longitude]} zoom={13} scrollWheelZoom={true}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker
                position={[
                  state.listingInfo.latitude,
                  state.listingInfo.longitude,
                ]}
              >
                <Popup>
                  {state.listingInfo.title}
                </Popup>
              </Marker>
              {state.listingInfo.listing_pois_within_10km.map(poi =>{
                return (
                  <Marker key={poi.id} 
                  position={[poi.location.coordinates[0], 
                  poi.location.coordinates[1]]}
                  icon={POiIcon(poi)}
                  >
                    <Popup>{poi.name}</Popup>
                  </Marker>
                );
              })}
            </MapContainer>
          </Grid>
          {userId == state.listingInfo.seller ? (
            <Grid item container justifyContent="space-around">
              <Button variant='contained' color='primary' onClick={handleUpdateOpen}>Update</Button>
              <Button variant='contained' color='error' onClick={handleDeleteOpen}>Delete</Button>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {/* Modal for delete confirmation */}
        <Dialog open={deleteDialogOpen} onClose={handleClose}>
          <DialogTitle>{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this listing? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Update Confirmation Dialog */}
        <Dialog open={updateDialogOpen} onClose={handleClose}>
          <DialogTitle>
            <IconButton
              // aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <ListingUpdate listingData={state.listingInfo} fullScreen closeDialog={handleClose} />
        </Dialog>
      </Container>
    </>
  );
}

export default ListingDetail;

// import React, { useEffect, useState } from 'react';
// import Cookies from "js-cookie";
// import api from '../utils/axiosInstance';
// import { useImmerReducer } from 'use-immer';
// import { Button, TextField, Container, Typography, Box, Grid, Avatar, CircularProgress, 
//         IconButton, Card, CardMedia, CardActions, CardContent, Link, Breadcrumbs } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import { useNavigate, useParams } from 'react-router-dom';
// import { makeStyles } from '@mui/styles';
// import defaultProfilePicture from "./Assets/default3.jpg";
// import axios from 'axios';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
// import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
// import RoomIcon from '@mui/icons-material/Room';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';

// const useStyles = makeStyles({
//   sliderContainer: {
//     position: 'relative',
//     marginTop: '1rem',
//     width: '100%', // Adjust container width
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   leftArrow: {
//     position: 'absolute',
//     cursor: 'pointer',
//     fontSize: '3rem',
//     color:'#1976d2',
//     top: '50%', // Keep it vertically centered relative to the image
//     left: '5%',  // Place on the left side
//     zIndex: 10, // Ensure it's on top of the image
//     '&:hover': {
//       backgroundColor: 'black', // Add hover effect for better UI rgba(0, 0, 0, 0.5)
//       borderRadius: '50%',
//     }
//   },
//   rightArrow: {
//     position: 'absolute',
//     cursor: 'pointer',
//     fontSize: '3rem',
//     color: '#1976d2',
//     top: '50%', // Keep it vertically centered relative to the image
//     right: '5%', // Place on the right side
//     zIndex: 10, // Ensure it's on top of the image
//     '&:hover': {
//       backgroundColor: 'black', // Add hover effect for better UI
//       borderRadius: '50%',
//     }
//   }
// });

// function ListingDetail() {
//   const navigate = useNavigate();
//   const params = useParams(); // This should be fine
//   const classes = useStyles();

//   const initialState = {
//     dataIsLoading: true,
//     listingInfo: "",
//   };

//   function ReducerFunction(draft, action) {
//     switch (action.type) {
//       case "catchListingInfo":
//         draft.listingInfo = action.listingObject;
//         break;
//       case "loadingDone":
//         draft.dataIsLoading = false;
//         break;
//       default:
//         break;
//     }
//   }

//   const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);

//   useEffect(() => {
//     console.log("params", params);
//     async function GetListingInfo() {
//       try {
//         const userCookie = Cookies.get('user');
//         const userId = userCookie ? JSON.parse(userCookie).user_id : null;
//         const response = await api.get(`http://localhost:8000/api/listing/${params.id}/`);
        
//         console.log(response.data)
//         dispatch({
//           type: "catchListingInfo",
//           listingObject: response.data,
//         });

//         dispatch({type: 'loadingDone'});

//       } catch (e) {
//         console.log(e.response);
//       }
//     }
//     GetListingInfo();
//   }, []);

//   const listingPictures = [
//     state.listingInfo.picture1,
//     state.listingInfo.picture2,
//     state.listingInfo.picture3,
//     state.listingInfo.picture4,
//     state.listingInfo.picture5,
//   ].filter((picture) => picture !== null);

//   const [currentPicture, setCurrentPicture] = useState(0);

//   function NextPicture() {
//     if (currentPicture === listingPictures.length - 1) {
//       return setCurrentPicture(0);
//     } else {
//       return setCurrentPicture(currentPicture + 1);
//     }
//   }

//   function PreviousPicture() {
//     if (currentPicture === 0) {
//       return setCurrentPicture(listingPictures.length - 1);
//     } else {
//       return setCurrentPicture(currentPicture - 1);
//     }
//   }

//   // const date = new Date(state.listingInfo_date_posted);

//   // const formattedDate = `${
//   //   date.getMonth() + 1
//   // }/${date.getDate()}/${date.getFullYear()}`;

// const date = state.listingInfo.date_posted ? new Date(state.listingInfo.date_posted) : null;

// const formattedDate = date
//   ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
//   : 'Date not available'; // Fallback if the date is invalid

 
//   if (state.dataIsLoading === true) {
//     return(
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     )
//   }

//   return (
//     <>
//     <Header />
//     <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Agency Detail
//         </Typography>
//     </Box>
//     <div style={{marginLeft: "1rem", marginRight: "1rem", marginBottom: "1rem" }}>
//       <Grid item style={{marginTop: "1rem"}}>
//         <Breadcrumbs aria-label="breadcrumb">
//           <Link underline="hover" color="inherit" onClick={() => navigate("/listing")} 
//           style={{cursor: "pointer"}}>
//             Listing
//           </Link>
//           {/* <Link
//             underline="hover"
//             color="inherit"
//             href="/material-ui/getting-started/installation/"
//           >
//             Core
//           </Link> */}
//           <Typography sx={{ color: 'text.primary' }}>{state.listingInfo.title}</Typography>
//         </Breadcrumbs>
//       </Grid>
//       <Grid item container justifyContent="center" className={classes.sliderContainer}>
//         {listingPictures.map((picture, index) => (
//           <div key={index}>
//             {index === currentPicture && (
//               <img 
//                 src={picture} 
//                 alt={`Listing picture ${index + 1}`} 
//                 style={{ width: "45rem", height: "35rem" }} 
//               />
//             )}
//           </div>
//         ))}
//         {/* Add onClick handlers to arrows */}
//         <ArrowCircleLeftIcon 
//           className={classes.leftArrow} 
//           onClick={PreviousPicture} // Handle previous picture action
//         />
//         <ArrowCircleRightIcon 
//           className={classes.rightArrow} 
//           onClick={NextPicture} // Handle next picture action
//         />
//       </Grid>
//       <Grid item container style={{padding: "1rem", border: "1px solid black", marginTop: "1rem"}}>
//         <Grid item container xs={7} direction="column" spacing={1}>
//           <Grid item>
//             <RoomIcon /> {" "}
//             <Typography variant='h6'>{state.listingInfo.district}</Typography>
//           </Grid>
//           <Grid item>
//             <Typography variant='subtitle1'>{formattedDate}</Typography>
//           </Grid>
//         </Grid>
//         <Grid item container xs={5} alignItems="center">
//           <Typography variant='h6' style={{fontWeight: "bolder", color: "green"}}>
//             {state.listingInfo.listing_type} | {" "}
//             {state.listingInfo.property_status === "Sale"
//               ? `$${state.listingInfo.price
//                 .toString()
//                 .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`  // Corrected regex for thousands separator
//               : `$${state.listingInfo.price
//                 .toString()
//                 .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/${state.listingInfo.rental_frequency}`
//             }
//           </Typography>
//         </Grid>
//         <Grid item container justifyContent="flex-start" style={{padding: "1rem", border: "1rem solid black", marginTop: "1rem"}}>
//           {state.listingInfo.furnished ? (
//             <Grid item style={{display: "flex"}}>
//               <CheckBoxIcon style={{color: "green", fontSize: "2rem"}} /> {""}
//               <Typography variant='h6'>Furnished</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//           {state.listingInfo.pool ? (
//             <Grid item style={{display: "flex"}}>
//               <CheckBoxIcon style={{color: "green", fontSize: "2rem"}} /> {""}
//               <Typography variant='h6'>Pool</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//           {state.listingInfo.elevator ? (
//             <Grid item style={{display: "flex"}}>
//               <CheckBoxIcon style={{color: "green", fontSize: "2rem"}} /> {""}
//               <Typography variant='h6'>Elevator</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//           {state.listingInfo.cctv ? (
//             <Grid item style={{display: "flex"}}>
//               <CheckBoxIcon style={{color: "green", fontSize: "2rem"}} /> {""}
//               <Typography variant='h6'>Cctv</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//           {state.listingInfo.parking ? (
//             <Grid item style={{display: "flex"}}>
//               <CheckBoxIcon style={{color: "green", fontSize: "2rem"}} /> {""}
//               <Typography variant='h6'>Parking</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//           {/* {state.listingInfo.rooms ? (
//             <Grid item xs={2} style={{display: "flex"}}>
//               <Typography variant='h6'>{state.listingInfo.rooms} Rooms</Typography>
//             </Grid>
//           ):(
//             ""
//           )} */}
//         </Grid>
//         {state.listingInfo.rooms ? (
//             <Grid item xs={2} style={{display: "flex"}}>
//               <Typography variant='h6'>{state.listingInfo.rooms} Rooms</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//           {state.listingInfo.description ? (
//             <Grid item style={{padding: "1rem", border:"1px solid black", marginTop: "1rem"}}>
//               <Typography variant='h6'>Description</Typography>
//               <Typography variant='h6'>{state.listingInfo.description}</Typography>
//             </Grid>
//           ):(
//             ""
//           )}
//       </Grid>
//     </div>
//     </>
//   )
// }

// export default ListingDetail
